import React from "react";

const Favourited = ({
  width = 24,
  height = 25,
  fill = "#BBBBBB",
  ...props
}) => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3328_85493)">
      <path
        d="M18.2571 2.85691C17.3469 2.03894 16.1789 1.61629 14.9993 1.65144C13.5348 1.65144 12.0567 2.253 10.9758 3.36941L10.2063 4.16121L9.43676 3.36941C8.35472 2.253 6.87816 1.65144 5.41332 1.65144C4.23363 1.65144 3.06683 2.03933 2.12191 2.85691C-0.305437 4.95808 -0.426922 8.70456 1.76136 10.9663L9.30824 18.7671C9.55785 19.0225 9.87816 19.1514 10.2024 19.1514C10.5278 19.1514 10.8543 19.0238 11.1012 18.7685L18.6442 10.9677C20.8391 8.70222 20.718 4.95613 18.2571 2.85691ZM17.3 9.66316L10.2063 16.9991L3.11019 9.66316C1.85081 8.36238 1.55238 5.79597 3.34925 4.27449C4.90785 2.92527 7.04418 3.59089 8.09144 4.67175L10.2075 6.85613L12.3231 4.67175C13.3551 3.60652 15.4973 2.91824 17.0653 4.27449C18.843 5.8155 18.5852 8.33503 17.3 9.66316Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_3328_85493">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.206055 0.401367)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default Favourited;
